
<template>
    <div class="container-fluid p-0" id="form">
          <div class="row" v-if='type==="save"' id="customFieldScroll">
              <template v-for='i in customField' :key="i._id.$oid">
              <div class="col-sm-6 float-left" v-if="edit==false && i.field_type!==6 && i.field_type!==7 && customFieldType===undefined">
                  <div class="row">
                      <div class="col-12 float-left" v-if='i.field_type===1'>
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="text" :id="i._id.$oid" @input="changeValue($event,1)" v-model="resetInput[i._id.$oid]" class="new-input">
                      </div>
                      <div class="col-12 float-left" v-if='i.field_type===2' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="number" onwheel="this.blur()" :id="i._id.$oid" @input="changeValue($event,2)" v-model="resetInput[i._id.$oid]" class="new-input">
                      </div>
                      <div class="col-12" v-if='i.field_type===3' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" :id="i._id.$oid"  :label="$ml.get('SELECT_DATE')" class="new-ctk" v-model="addCustomDate[i._id.$oid]" @input="addCustomDateObj['id']=i._id.$oid,addCustomDateObj['value'] = addCustomDate[i._id.$oid],changeValue(addCustomDateObj,3)" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                      </div>
                      
                      <div class="col-12" v-if='i.field_type===4' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <select :id="i._id.$oid" class="new-select bg-white" v-model="resetInput[i._id.$oid]" @input="changeValue($event,4)">
                              <option value="0" selected>Seçiniz...</option>
                              <option v-for="u in validUsers" :value="u._id.$oid">{{u.name}} {{u.surName}}</option>
                          </select>
                      </div>
                      <div class="col-12" v-if='i.field_type===5' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="text" :id="i._id.$oid" @input="changeValue($event,5)" v-model="resetInput[i._id.$oid]" class="new-input">
                      </div>
                      <div class="col-12" v-if='i.field_type===8 && organizationArray.find(c=>c.id==i._id.$oid)!==undefined' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <div>
                              <div class="position-relative">
                                  <input  type="text" class="new-input-disable"
                                   :disabled="selected!=i._id.$oid" :id="i._id.$oid"  @input="changeOrganizationArray($event,i._id.$oid)" v-model="organizationArray.find(c=>c.id==i._id.$oid).name" >
                                  <div class="input-plus-absolute-right h40">
                                      <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm " style="color:rgba(51,51,51,0.75)"></i>
                                      <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-check color-green cursor-pointer font-sm"></i>
      
                                  </div>
                              </div>
                          </div>
                          <ul class="new-dropdown dropdown-menu-left m-0 p-0 position-absolute z-8" v-show='organizationArray.find(c=>c.id==i._id.$oid).isHidden'>
                              <li class="autocomplete-result" v-for='(result, index) in items' :key="index" @click="setResult(result,'organization',i._id.$oid)">{{result.name}}</li>
                          </ul>
                      </div>
                      <div class="col-12" v-if='i.field_type===9 && contactArray.find(c=>c.id==i._id.$oid)!==undefined' >
                          <label class="new-label">{{filterName(i.name)}}:</label>
                          <div>
                              <div class="position-relative">
                                  <input type="text" class="new-input-disable" :disabled="selected!=i._id.$oid" :id="i._id.$oid" @input="changeContactArray($event,i._id.$oid)" v-model="contactArray.find(c=>c.id==i._id.$oid).name">
                                  <div class="input-plus-absolute-right h40">
                                      <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                      <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-check color-green cursor-pointer font-sm"></i>
                                  </div>
                              </div>
                          </div>
                          <ul class="new-dropdown autocomplete-results" v-show='contactArray.find(c=>c.id==i._id.$oid).isHidden'>
                            <li class="autocomplete-result" v-for='(result, index) in items' :key="index" @click="setResult(result,'contact',i._id.$oid)">{{result.n}} {{result.sn}} <span v-if="result.organizationName!=undefined" class="color-red">({{filterName(result.organizationName)}})</span><span v-else class="color-red">(Firma Yok)</span></li>
                        </ul>
                      </div>
                      <div class="col-12" v-if='i.field_type===10' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="number" onwheel="this.blur()" :id="i._id.$oid" @input="changeValue($event,10)" v-model="resetInput[i._id.$oid]" class="new-input">
                      </div>
                      <div class="col-12" v-if='i.field_type===11' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="text" :id="i._id.$oid" @input="changeValue($event,11)" v-model="resetInput[i._id.$oid]" class="new-input">
                      </div>
                      <div class="col-12 float-left" v-if='i.field_type===12'>
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="number" onwheel="this.blur()" :id="i._id.$oid" @input="changeValue($event,12,i)" v-model="resetInput[i._id.$oid]" class="new-input">
                      </div>
                      
                  </div>
              </div>
              </template>
              <!-- AKTİVİTE İÇİN ÖZEL ALANLAR  6 ve 7 hariç field-->
              <template v-for='i in customField' :key="i._id.$oid">
              <div class="col-sm-6 float-left" v-if="edit==false && i.field_type!==6 && i.field_type!==7 && customFieldType!==undefined && domain===i.domain">
                
                  <div class="row">
                      <div class="col-12 float-left" v-if='i.field_type===1'>
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="text" :id="i._id.$oid" @input="changeValue($event,1)" class="new-input">
                      </div>
                      <div class="col-12 float-left" v-if='i.field_type===2' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="number" onwheel="this.blur()" :id="i._id.$oid" @input="changeValue($event,2)" class="new-input">
                      </div>
                      <div class="col-12" v-if='i.field_type===3' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" :id="i._id.$oid"  :label="$ml.get('SELECT_DATE')" class="new-ctk" v-model="addCustomDate[i._id.$oid]" @input="addCustomDateObj['id']=i._id.$oid,addCustomDateObj['value']=addCustomDate[i._id.$oid],changeValue(addCustomDateObj,3)" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                          <!-- burada yok -->
                      </div>
                      <div class="col-12" v-if='i.field_type===4' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <select :id="i._id.$oid" class="new-select bg-white" @input="changeValue($event,4)">
                              <option value="0" selected>Seçiniz...</option>
                              <option v-for="u in validUsers" :value="u._id.$oid">{{u.name}} {{u.surName}}</option>
                          </select>
                      </div>
                      <div class="col-12" v-if='i.field_type===5' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="text" :id="i._id.$oid" @input="changeValue($event,5)" class="new-input">
                      </div>
                      <div class="col-12" v-if='i.field_type===8' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <div>
                              <div class="position-relative">
                                  <input type="text" class="new-input-disable" @input="changeValue($event,8)" :disabled="selected!=i._id.$oid" :id="i._id.$oid" :placeholder="filterName(i.name)" v-model="organization" >
                                  <div class="input-plus-absolute-right h40">
                                      <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                      <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-check color-green cursor-pointer font-sm"></i>
      
                                  </div>
                              </div>
                          </div>
                          <ul class="new-dropdown dropdown-menu-left m-0 p-0 position-absolute z-8" v-show='isHiddenOrganization'>
                              <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'organization')">{{result.name}}</li>
                          </ul>
                      </div>
                      <div class="col-12" v-if='i.field_type===9' >
                          <label class="new-label">{{filterName(i.name)}}:</label>
                          <div>
                              <div class="position-relative">
                                  <input type="text" class="new-input-disable" @input="changeValue($event,9)" :disabled="selected!=i._id.$oid" :id="i._id.$oid" :placeholder="filterName(i.name)" v-model="contact">
                                  <div class="input-plus-absolute-right h40">
                                      <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                      <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-check color-green cursor-pointer font-sm"></i>
                                  </div>
                              </div>
                          </div>
                          <ul class="new-dropdown autocomplete-results" v-show='isHiddenContact'>
                            <li class="autocomplete-result" v-for='(result, i) in items' :key="i" @click="setResult(result,'contact')">{{result.n}} {{result.sn}} <span v-if="result.organizationName!=undefined" class="color-red">({{filterName(result.organizationName)}})</span><span v-else class="color-red">(Firma Yok)</span></li>
                          </ul>
                      </div>
                      <div class="col-12" v-if='i.field_type===10' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="number" onwheel="this.blur()" :id="i._id.$oid" @input="changeValue($event,10)" class="new-input">
                      </div>
                      <div class="col-12" v-if='i.field_type===11' >
                          <label class="new-label">{{filterName(i.name)}}</label>
                          <input type="text" :id="i._id.$oid" @input="changeValue($event,11)" class="new-input">
                      </div>
                  </div>
              </div>
              </template>
              
              <hr class="w-100 border-line-80 mt-4 mb-3">
              
              <template v-for='(i,index) in customField' :key="index">
              <div class="col-sm-6 float-left" v-if='edit==false && (i.field_type===6 || i.field_type===7)'>
                  <div id="accordion">
                      <div class="row">
                          <!--Add Custom Field Part-->
                          <div class="col-12" v-if='i.field_type===6 && customFieldType===undefined' >
                              <label class="new-label">{{filterName(i.name)}}:</label>
                              <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                               <label class="new-input cursor-pointer" type="text" v-if="radioCheck[i._id.$oid]==undefined">Seçiniz</label>
                                <span v-else>
                                    <template v-for='d in i.options' :key="d.id">
                                    <label class="new-input cursor-pointer" type="text" v-if="customFieldChecked(radioCheck[i._id.$oid],d.id)" >{{d.label}}</label>
                                    </template>
                                </span>
                              </div>
                              <div class="new-dropdown dropdown-menu dropdown-menu-left multiChoose p-0">
                                  <div class="multiChoose">
                                      <template v-if="i.options!==undefined">
                                      <div v-for='d in i.options' :key="d.id">
                                          <label class="w-100">
                                              <input type="radio" :checked="customFieldChecked(radioCheck[i._id.$oid],d.id)" :id="i._id.$oid" :value="d.id" @click="changeValue($event,6)"> 
                                              <span class="label-text" :title="d.label">{{d.label}}</span>
                                          </label>
                                      </div>
                                      </template>
                                  </div>
                              </div>
                          </div>
                          <div class="col-12" v-if='i.field_type===7 && customFieldType===undefined' >
                              <label class="new-label" >{{filterName(i.name)}}:</label>
                              <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="cursor-pointer">
                                <label class="new-input cursor-pointer dropdown-toggle d-flex justify-content-between align-items-center " type="text" v-if="checkboxCheck[i._id.$oid]==undefined || multiChoose[i._id.$oid].length===0">Seçiniz</label>
                                <span v-else>
                                      <label class="new-input cursor-pointer " type="text"><template v-for='d in i.options' :key="d.id"><span v-if="customFieldChecked(checkboxCheck[i._id.$oid],d.id)">{{d.label}};</span></template></label>
                                </span>
                              </div>
                              <div class="new-dropdown dropdown-menu dropdown-menu-left dropMenu multiChoose p-0">
                                  <div class="multiChoose">
                                      <template v-if="i.options!==undefined">
                                      <div v-for='d in i.options' :key="d.id">
                                          <label class="w-100">
                                              <input type="checkbox" :checked="customFieldChecked(checkboxCheck[i._id.$oid],d.id)" :id="i._id.$oid" :value="d.id" @click="changeValue($event,7)"> 
                                              <span class="label-text" :title="d.label">{{d.label}}</span>
                                          </label>
                                      </div>
                                      </template>
                                  </div>
                              </div>
                          </div>
                          
                      </div>
                  </div>
              </div>
              </template>
              <!-- AKTİVİTE İÇİN ÖZEL ALANLAR 6 ve 7 field -->
              <template v-for='(i,index) in customField' :key="index">
              <div class="col-sm-6 float-left" v-if='edit==false && (i.field_type===6 || i.field_type===7)'>
                  <div id="accordion">
                      <div class="row">
                          <div class="col-12" v-if='i.field_type===6 && customFieldType!==undefined && domain===i.domain' >
                             <label class="new-label">{{filterName(i.name)}}:</label>
                              <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <label class="new-input cursor-pointer" type="text" v-if="radioCheck[i._id.$oid]==undefined">Seçiniz</label>
                                <span v-else>
                                    <template v-for='d in i.options' :key="d.id">
                                    <label class="new-input cursor-pointer" type="text" v-if="customFieldChecked(radioCheck[i._id.$oid],d.id)" >{{d.label}}</label>
                                    </template>
                                </span>
                              </div>
                              <div class="new-dropdown dropdown-menu dropdown-menu-left multiChoose p-0">
                                  <div class="multiChoose">
                                      <template v-if="i.options!==undefined">
                                      <div v-for='d in i.options' :key="d.id">
                                          <label class="w-100">
                                              <input type="radio" :name="i._id.$oid" :id="i._id.$oid" :value="d.id" @click="changeValue($event,6)"> 
                                              <span class="label-text" :title="d.label">{{d.label}}</span>
                                          </label>
                                      </div>
                                      </template>
                                  </div>
                              </div>
                          </div>
                          <div class="col-12" v-if='i.field_type===7 && customFieldType!==undefined && domain===i.domain' >
                               <label class="new-label" >{{filterName(i.name)}}:</label>
                              <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="cursor-pointer">
                                <label class="new-input cursor-pointer" type="text" v-if="checkboxCheck[i._id.$oid]==undefined">Seçiniz</label>
                                <span v-else>
                                      <label class="new-input cursor-pointer" type="text"><template v-for='d in i.options' :key="d.id"><span v-if="customFieldChecked(checkboxCheck[i._id.$oid],d.id)">{{d.label}};</span></template></label>
                                </span>
                              </div>
                              <div class="new-dropdown dropdown-menu dropdown-menu-left dropMenu multiChoose p-0">
                                  <div class="multiChoose">
                                      <template v-if="i.options!==undefined">
                                      <div v-for='d in i.options' :key="d.id">
                                          <label class="w-100">
                                              <input type="checkbox" :id="i._id.$oid" :value="d.id" @click="changeValue($event,7)"> 
                                              <span class="label-text" :title="d.label">{{d.label}}</span>
                                          </label>
                                      </div>
                                      </template>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              </template>
              <div class="row m-0 w-100" v-if="edit===true">
                  <template v-for='i in customField' :key="i._id.$oid">
                  <div class="col-sm-6 float-left field" v-if='editList[i._id.$oid]!==undefined && i.field_type!==6 && i.field_type!==7'>
                      <div v-if="i.field_type===1">
                          <div>
                              <label class="new-label">{{filterName(i.name)}}:</label>
                              <div class="position-relative">
                                  <input type="text" class="new-input-disable" :disabled="selected!=i._id.$oid" placeholder="Boş" :id="i._id.$oid" v-model="editList[i._id.$oid]" v-on:keyup.13="update(editList,i._id.$oid,editList[i._id.$oid])">
                                  <div class="input-plus-absolute-right h40">
                                      <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                      <i @click="update(editList,i._id.$oid,editList[i._id.$oid])" v-show="selected==i._id.$oid" class="mr-2 fa fa-check color-green cursor-pointer"></i>
                                      <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-times color-red cursor-pointer font-sm"></i>
      
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div v-if="i.field_type===2 || i.field_type===5  || i.field_type===10 || i.field_type===12">
                          <!-- Numeric -->
                          <div>
                              <label class="new-label">{{filterName(i.name)}}:</label>
                              <div class="position-relative">
                                  <input type="number" onwheel="this.blur()" class="new-input-disable" :disabled="selected!=i._id.$oid" placeholder="Boş" :id="i._id.$oid" v-model="editList[i._id.$oid]" v-on:keyup.13="update(editList,i._id.$oid,editList[i._id.$oid])">
                                  <div class="input-plus-absolute-right h40">
                                      <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                      <i @click="update(editList,i._id.$oid,editList[i._id.$oid])" v-show="selected==i._id.$oid" class="mr-2 fa fa-check color-green cursor-pointer"></i>
                                      <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-times color-red cursor-pointer font-sm"></i>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div v-if="i.field_type===3">
                          <div>
                              <label class="new-label">{{filterName(i.name)}}:</label>
                              <div class="position-relative">
                                  <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" :disabled="selected!=i._id.$oid" :id="i._id.$oid"  :label="$ml.get('SELECT_DATE')" class="new-ctk" v-model="editList[i._id.$oid]" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                                  <div class="input-plus-absolute-right h40">
                                      <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                      <i @click="update(editList,i._id.$oid,editList[i._id.$oid])" v-show="selected==i._id.$oid" class="mr-2 fa fa-check color-green cursor-pointer"></i>
                                      <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-times color-red cursor-pointer font-sm"></i>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div v-if="i.field_type===4">
                          <div v-if="editList[i._id.$oid] && editList[i._id.$oid]._id!=null">
                              <label class="new-label">{{filterName(i.name)}}:</label>
                              <select :id="i._id.$oid" v-model="editList[i._id.$oid]._id.$oid"  @input="update(editList,i._id.$oid,editList[i._id.$oid]._id)" class="new-select bg-white">
                                  <option v-for="u in validUsers" :value="u._id.$oid" :selected="editList[i._id.$oid]._id.$oid===u._id.$oid">{{u.name}} {{u.surName}}</option>
                              </select>
                          </div>
                          <div v-else>
                            <label class="new-label">{{filterName(i.name)}}:</label>
                            <select :id="i._id.$oid"  @input="update(editList,i._id.$oid,{'$oid':$event.srcElement.value})" class="new-select bg-white">
                                <option v-for="u in validUsers" :value="u._id.$oid">{{u.name}} {{u.surName}}</option>
                            </select>
                          </div>
                      </div>
                      <div v-if="i.field_type===8">
                          <label class="new-label">{{filterName(i.name)}}:</label>
                          <div>
                              <div class="position-relative">
                                  <input v-if="editList[i._id.$oid]!=null && editList[i._id.$oid].name!=undefined" type="text" class="new-input" :disabled="selected!=i._id.$oid" :id="i._id.$oid" @input="changeOrganizationArray($event,i._id.$oid)" v-model="organizationArray.find(c=>c.id==i._id.$oid).name" @dblclick="selected=i._id.$oid">
                                  <input v-else type="text" class="new-input-disable" :disabled="selected!=i._id.$oid" :id="i._id.$oid" @input="changeOrganizationArray($event,i._id.$oid)" v-model="organizationArray.find(c=>c.id==i._id.$oid).name"  @dblclick="selected=i._id.$oid">
                                  <div class="input-plus-absolute-right h40">
                                      <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                      <i @click="update(editList,i._id.$oid,'')" v-show="selected==i._id.$oid" class="mr-2 fa fa-trash color-red cursor-pointer"></i>
                                      <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-check color-green cursor-pointer font-sm"></i>
      
                                  </div>
                              </div>
                          </div>
                          <ul class="new-dropdown dropdown-menu-left m-0 p-0 position-absolute z-8" v-show='organizationArray.find(c=>c.id==i._id.$oid).isHidden'>
                              <li class="autocomplete-result" v-for='(result, index) in items' :key="index" @click="setResult(result,'profilOrganization',i._id.$oid)">{{result.name}}</li>
                          </ul>
                      </div>
                      <div v-if="i.field_type===9">
                          
                          <label class="new-label">{{filterName(i.name)}}:</label>
                          
                          <div>
                              <div class="position-relative">
                                  <input v-if="editList[i._id.$oid]!=null && editList[i._id.$oid].n!=undefined" type="text" class="new-input" :disabled="selected!=i._id.$oid" :id="i._id.$oid" @input="changeContactArray($event,i._id.$oid)" v-model="contactArray.find(c=>c.id==i._id.$oid).name" @dblclick="selected=i._id.$oid">
                                  <input v-else type="text" class="new-input-disable" :disabled="selected!=i._id.$oid" :id="i._id.$oid" @input="changeContactArray($event,i._id.$oid)" v-model="contactArray.find(c=>c.id==i._id.$oid).name" @dblclick="selected=i._id.$oid">
                                  <div class="input-plus-absolute-right h40">
                                      <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                      <i @click="update(editList,i._id.$oid,'')" v-show="selected==i._id.$oid" class="mr-2 fa fa-trash color-red cursor-pointer"></i>
                                      <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-check color-green cursor-pointer font-sm"></i>
                                  </div>
                              </div>
                          </div>
                          <ul class="new-dropdown autocomplete-results" v-show='contactArray.find(c=>c.id==i._id.$oid).isHidden'>
                            <li class="autocomplete-result" v-for='(result, index) in items' :key="index" @click="setResult(result,'profilContact',i._id.$oid)">{{result.n}} {{result.sn}} <span v-if="result.organizationName!=undefined" class="color-red">({{filterName(result.organizationName)}})</span><span v-else class="color-red">(Firma Yok)</span></li>
                         </ul>
                      </div>
                  </div>
                  </template>
                  <template v-for='(i,index) in customField' :key="index">
                  <div class="col-sm-6 float-left" v-if='editList[i._id.$oid]!==undefined && (i.field_type===6 || i.field_type===7)'>
                      <div id="accordion">
                          <div class="row">
                              <div class="col-12" v-if="i.field_type===6">
                                  <label class="new-label">{{filterName(i.name)}}:</label>
                                  <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <span v-if="(editList[i._id.$oid]!==undefined && editList[i._id.$oid]!==null && editList[i._id.$oid]!=='') ||  editList[i._id.$oid]=='0'">
                                        <template v-for='d in i.options' :key="d.id">
                                        <label class="new-input cursor-pointer" type="text" v-if="customFieldChecked(editList[i._id.$oid],d.id)">{{d.label}}</label>
                                        </template>
                                      </span>
                                      <label v-else class="new-input cursor-pointer" type="text">Seçiniz</label>
                                      
                                  </div>
                                  <div class="new-dropdown dropdown-menu dropdown-menu-left multiChoose p-0">
                                      <div class="multiChoose">
                                          <template v-if="i.options!==undefined">
                                          <div v-for='d in i.options' :key="d.id">
                                              <label class="w-100">
                                                  <input type="radio" :checked="customFieldChecked(editList[i._id.$oid],d.id,'edit')" :id="i._id.$oid" :value="d.id" @click="updateChooseCustomField(editList[i._id.$oid],$event)"> 
                                                  <span class="label-text" :title="d.label">{{d.label}}</span>
                                              </label>
                                          </div>
                                          </template>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-12" v-if="i.field_type===7">
                                  <label class="new-label" >{{filterName(i.name)}}:</label>
                                  <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="cursor-pointer">
                                    <label class="new-input cursor-pointer" type="text" v-if="editList[i._id.$oid].length==0">Seçiniz</label>
                                    <span v-else>
                                      <label class="new-input cursor-pointer" type="text"><template v-for='d in i.options' :key="d.id"><span v-if="customFieldChecked(editList[i._id.$oid],d.id)">{{d.label}};</span></template></label>
                                    </span>
                                  </div>
                                  <div class="new-dropdown dropdown-menu dropdown-menu-left dropMenu multiChoose p-0">
                                      <div class="multiChoose">
                                          <template v-if="i.options!==undefined">
                                          <div v-for='d in i.options' :key="d.id">
                                              <label class="w-100">
                                                  <input type="checkbox" :checked="customFieldChecked(editList[i._id.$oid],d.id,'edit')" :id="i._id.$oid" :value="d.id" @click="updateChooseCustomField(editList[i._id.$oid],$event)"> 
                                                  <span class="label-text" :title="d.label">{{d.label}}</span>
                                              </label>
                                          </div>
                                          </template>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  </template>
              </div>
          </div>
        <div class="row custom-field-profile" v-if='type==="profil"'>
            <div class="col-12">
                
                <div class="row justify-content-end">
                <button type="button" :title="$ml.get('SETTINGS')" class="mt-3 mr-3 bg-white border btn btn-click p-2 dropdown-button hover-bg-primary light-gray-color float-right" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                    <label class="p-0 m-0 btn-click">{{$ml.get('SETTINGS')}}</label>
                    <i class="fa fa-sliders font-m ml-2"></i>
                </button>
                <div class="dropdown-menu new-dropdown dropdown-menu-right multiChoose" aria-labelledby="settings" >
                    <template v-for="c in customField" :key="c._id.$oid">
                    <div v-if="data[c._id.$oid]===undefined">
                        <label class="w-100">
                            <input type="checkbox" name="check" :checked="checkArray.indexOf(c._id.$oid)!==-1" :id="c._id.$oid" :value="c._id.$oid" @click="setDisplayField"> <span class="label-text f-14">{{c.name}}</span>
                        </label>
                    </div>
                    </template>
                    <hr>
                    <template v-for="c in customField" :key="c._id.$oid">
                    <div v-if="data[c._id.$oid]!==undefined">
                        <label class="w-100">
                            <input type="checkbox" :value="c._id.$oid" name="check" @click="setDisplayField" checked> <span class="label-text f-14">{{c.name}}</span>
                        </label>
                    </div>
                    </template>
                    <div class="col-12 dealBtnStyle d-none">
                        <button class="btn btn-lg btn-primary ml-3 float-right h-32">{{$ml.get('SAVE')}}</button>
                        <button class="btn btn-lg btn-primary float-right h-32">{{$ml.get('CANCEL')}}</button>
                    </div>
                </div>
                </div>
            </div>
            <div class="row">
                <template v-for='i in customField' :key="i._id.$oid">
                <div class="col-sm-6 float-left field p-2" v-if='detailEditList[i._id.$oid]!==undefined && i.field_type!==6 && i.field_type!==7 && checkArray.indexOf(i._id.$oid)!==-1'>
                    <div v-if="i.field_type===1">
                        <div>
                            <label class="new-label">{{filterName(i.name)}}:</label>
                            <div class="position-relative">
                                <input type="text" class="new-input-disable" :disabled="selected!=i._id.$oid" :id="i._id.$oid" placeholder="Boş" v-model="detailEditList[i._id.$oid]" v-on:keyup.13="update(detailEditList,i._id.$oid,detailEditList[i._id.$oid])"  @dblclick="selected=i._id.$oid">
                                <div class="input-plus-absolute-right h40">
                                    <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                    <i @click="update(detailEditList,i._id.$oid,detailEditList[i._id.$oid])" v-show="selected==i._id.$oid" class="mr-2 fa fa-check color-green cursor-pointer"></i>
                                    <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-times color-red cursor-pointer font-sm"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="i.field_type===2 || i.field_type===5 || i.field_type===10">
                        <div>
                            <label class="new-label">{{filterName(i.name)}}:</label>
                            <div class="position-relative">
                                <input type="number" onwheel="this.blur()" class="new-input-disable" :disabled="selected!=i._id.$oid" :id="i._id.$oid" v-model="detailEditList[i._id.$oid]" v-on:keyup.13="update(detailEditList,i._id.$oid,detailEditList[i._id.$oid])"  @dblclick="selected=i._id.$oid">
                                <div class="input-plus-absolute-right h40">
                                    <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                    <i @click="update(detailEditList,i._id.$oid,detailEditList[i._id.$oid])" v-show="selected==i._id.$oid" class="mr-2 fa fa-check color-green cursor-pointer"></i>
                                    <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-times color-red cursor-pointer font-sm"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="i.field_type===3">
                        <div>
                            <label class="new-label">{{filterName(i.name)}}:</label>
                            <div class="position-relative">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" :disabled="selected!=i._id.$oid" :id="i._id.$oid"  :label="$ml.get('SELECT_DATE')" class="new-ctk" v-model="detailEditList[i._id.$oid]" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true"></vue-ctk-date-time-picker>
                                <div class="input-plus-absolute-right h40">
                                    <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                    <i @click="update(detailEditList,i._id.$oid,detailEditList[i._id.$oid])" v-show="selected==i._id.$oid" class="mr-2 fa fa-check color-green cursor-pointer"></i>
                                    <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-times color-red cursor-pointer font-sm"></i>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                    <div v-if="i.field_type===4">
                        <label class="new-label">{{filterName(i.name)}}:</label>
                        <select v-if="detailEditList[i._id.$oid] && detailEditList[i._id.$oid]._id" :id="i._id.$oid" v-model="detailEditList[i._id.$oid]._id.$oid"  @change="update(detailEditList,i._id.$oid,detailEditList[i._id.$oid]._id)" class="new-select bg-white">
                            <option v-for="u in validUsers" :value="u._id.$oid" :selected="detailEditList[i._id.$oid]._id.$oid===u._id.$oid">{{u.name}} {{u.surName}}</option>
                        </select>
                        <select v-else :id="i._id.$oid" @change="update(detailEditList,i._id.$oid,{'$oid':$event.target.value})" class="new-select bg-white">
                            <option v-for="u in validUsers" :value="u._id.$oid">{{u.name}} {{u.surName}}</option>
                        </select>
                    </div>
                    <div v-if="i.field_type===8">
                        <label class="new-label">{{filterName(i.name)}}:</label>
                        <div>
                            <div class="position-relative">
                                <input type="text" class="new-input-disable" :disabled="selected!=i._id.$oid" :id="i._id.$oid" @input="changeOrganizationArray($event,i._id.$oid)" v-model="organizationArray.find(c=>c.id==i._id.$oid).name"  @dblclick="selected=i._id.$oid">
                                <div class="input-plus-absolute-right h40">
                                    <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                    <i @click="update(detailEditList,i._id.$oid,'')" v-show="selected==i._id.$oid" class="mr-2 fa fa-trash color-red cursor-pointer"></i>
                                    <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-check color-green cursor-pointer font-sm"></i>
                                </div>
                            </div>
                        </div>
                        <ul class="new-dropdown dropdown-menu-left m-0 p-0 position-absolute z-8" v-show='organizationArray.find(c=>c.id==i._id.$oid).isHidden'>
                            <li class="autocomplete-result" v-for='(result, index) in items' :key="index" @click="setResult(result,'profilOrganization',i._id.$oid)">{{result.name}}</li>
                        </ul>
                    </div>
                    <div v-if="i.field_type===9">
                        <label class="new-label">{{filterName(i.name)}}:</label>
                        <div>
                            <div class="position-relative">
                                <input type="text" class="new-input-disable" :disabled="selected!=i._id.$oid" :id="i._id.$oid"  @input="changeContactArray($event,i._id.$oid)" v-model="contactArray.find(c=>c.id==i._id.$oid).name"  @dblclick="selected=i._id.$oid">
                                <div class="input-plus-absolute-right h40">
                                    <i @click="selected=i._id.$oid" v-show="selected!=i._id.$oid" class="fas fa-pencil-alt cursor-pointer font-sm" style="color:rgba(51,51,51,0.75)"></i>
                                    <i @click="update(detailEditList,i._id.$oid,'')" v-show="selected==i._id.$oid" class="mr-2 fa fa-trash color-red cursor-pointer"></i>
                                    <i @click="selected=undefined" v-show="selected==i._id.$oid"  class="fa fa-check color-green cursor-pointer font-sm"></i>
                                </div>
                            </div>
                        </div>
                        <ul class="new-dropdown dropdown-menu-left m-0 p-0 position-absolute z-8" v-show='contactArray.find(c=>c.id==i._id.$oid).isHidden'>
                            <li class="autocomplete-result" v-for='(result, index) in items' :key="index" @click="setResult(result,'profilContact',i._id.$oid)">{{result.n}} {{result.sn}} <span v-if="result.organizationName!=undefined" class="color-red">({{filterName(result.organizationName)}})</span><span v-else class="color-red">(Firma Yok)</span></li>
                        </ul>
                        
                    </div>
                </div>
                </template>
                <template v-for='(i,index) in customField' :key="index">
                <div class="col-sm-6 float-left p-2" v-if='detailEditList[i._id.$oid]!==undefined && (i.field_type===6 || i.field_type===7) && checkArray.indexOf(i._id.$oid)!==-1'>
                        <div v-if="i.field_type===6">
                            <label class="new-label">{{filterName(i.name)}}:</label>
                            <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span v-if="(detailEditList[i._id.$oid]!==undefined && detailEditList[i._id.$oid]!==null && detailEditList[i._id.$oid]!=='') ||  detailEditList[i._id.$oid]=='0'">
                                <template v-for='d in i.options' :key="d.id">
                                <label class="new-input cursor-pointer" type="text" v-if="customFieldChecked(detailEditList[i._id.$oid],d.id)">{{d.label}}</label>
                                </template>
                                </span>
                                <label v-else class="new-input cursor-pointer" type="text">Seçiniz</label>
                                
                            </div>     
                            <div class="new-dropdown dropdown-menu dropdown-menu-left multiChoose p-0">
                                <div class="multiChoose">
                                    <template v-if="i.options!==undefined">
                                    <div v-for='d in i.options' :key="d.id">
                                        <label class="w-100">
                                            <input type="radio" :checked="customFieldChecked(detailEditList[i._id.$oid],d.id)" :id="i._id.$oid" :value="d.id" @click="updateChooseCustomField(detailEditList[i._id.$oid],$event)"> 
                                            <span class="label-text" :title="d.label">{{d.label}}</span>
                                        </label>
                                    </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div v-if="i.field_type===7">
                            <label class="new-label" >{{filterName(i.name)}}:</label>
                            <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="cursor-pointer">
                                <label class="new-input cursor-pointer" type="text" v-if="detailEditList[i._id.$oid].length==0">Seçiniz</label>
                                <span v-else>
                                <label class="new-input cursor-pointer" type="text"><template v-for='d in i.options' :key="d.id"><span v-if="customFieldChecked(detailEditList[i._id.$oid],d.id)">{{d.label}};</span></template></label>
                                </span>
                            </div>
                            <div class="new-dropdown dropdown-menu dropdown-menu-left dropMenu multiChoose p-0">
                                <div class="multiChoose">
                                    <template v-if="i.options!==undefined">
                                    <div v-for='d in i.options' :key="d.id">
                                        <label class="w-100">
                                            <input type="checkbox" :checked="customFieldChecked(detailEditList[i._id.$oid],d.id)" :id="i._id.$oid" :value="d.id" @click="updateChooseCustomField(detailEditList[i._id.$oid],$event)"> 
                                            <span class="label-text" :title="d.label">{{d.label}}</span>
                                        </label>
                                    </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                </div>
                </template>
            </div>
        </div>
    </div>
</template>
  <script>
  import Vue from 'vue'
  import axios from 'axios'
  import _ from 'underscore'
  import {mapState} from 'vuex'
  import {mapActions} from 'vuex'
  import {mapGetters} from 'vuex'
  import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
  Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
  export default {
      name: 'specialArea',
      data () {
          return {
              singleChoose:[],
              multiChoose:[],
              organization:'',
              contact:'',
              allCustomFields:{},
              selectContact:'',
              selectOrganization:'',
              isHiddenContact:false,
              isHiddenOrganization:false,
              items:[],
              addChooseItem:[],
              newData:[],
              selected:"",
              checkArray:[],
              addCustomDate:[],
              addCustomDateObj:{},
              detailEditList:[],
              editList:[],
              newRadioCheck:{},
              radioCheck:{},
              checkboxCheck:{},
              resetInput:{},
              contactArray:[],
              organizationArray:[],
              dateEvent: ""
          }
      },
      props:["type","customField","domain","data","user","users","postField","customFieldType","active","permission","edit","editArray"],
      computed: {
          ...mapState([
              'baseUrl',
              'editLine',
              'editLineStatu'
          ]),
          ...mapGetters(['localeLang']),
          listenState() { return this.$store.state.editLine },
          listenStateStatus() { return this.$store.state.editLineStatu },
          validUsers() {
              return (Array.isArray(this.users) ? this.users : []).filter(user =>
                  user && user._id && user._id.$oid
              )
          },
      },
      created(){
          
          this.setInputs()
          
      },
      methods:{
          filterName:function(value){
              if ( value && value.length > 20 ) {
                  return value.substring(0,20) + '...'
              } else {
                  return value || ''
              }
          },
          filterChooseName:function(value){
              if ( value && value.length > 15 ) {
                  return value.substring(0,15) + '...'
              } else {
                  return value || ''
              }
          },
          getFullNameOfContact(contact){
            var name=''
            var sname=''
            if(contact && contact.n!==""&&contact.n!==undefined&&contact.n!==null){
                name = contact.n
            }
            if(contact && contact.sn!==""&&contact.sn!==undefined&&contact.sn!==null){
                sname = contact.sn
            }
            return (name+' '+sname).trim()
          },
          changeContactArray: _.debounce(function(event) {
            var name=event.target.value
            var id=event.target.id
            if(name==""){
                this.contactArray.find(c=>c.id==id).isHidden = false
            } else{
                if(this.contactArray.find(c=>c.id==id).selectName!==name){
                    this.quickContact(id) 
                }
            }
          },300),
          changeOrganizationArray: _.debounce(function(event) {
            var name=event.target.value
            var id=event.target.id
            if(name==""){
                this.organizationArray.find(c=>c.id==id).isHidden = false
            } else{
                if(this.organizationArray.find(c=>c.id==id).selectName!==name){
                    this.quickOrganization(id) 
                }
            }
          },300),
          clearCustom(){
            
            this.singleChoos=[],
            this.multiChoose=[],
            this.radioCheck={}
            this.checkboxCheck={}
            this.allCustomFields={}
            this.resetInput=[]
            this.organization=''
            this.contact=''
            this.addCustomDate=[]
            this.addCustomDateObj={}
            if(this.edit==false){
            this.setCustomField()
            }
          },
          setCustomField(){
            this.contactArray=[]
            this.organizationArray=[]
            for(var cf in this.customField){
                if(this.customField[cf]['field_type']==9){
                    let id = this.customField[cf]['_id']['$oid']
                        var contactObj={}
                        contactObj= {
                            name:"",
                            id:id,
                            isHidden:false,
                            selectName:"",
                            cid:""
                        }
                        this.contactArray.push(contactObj)
                }
                if(this.customField[cf]['field_type']==8){
                    let id = this.customField[cf]['_id']['$oid']
                        var organizationObj={}
                        organizationObj= {
                            name:"",
                            id:id,
                            isHidden:false,
                            selectName:"",
                            cid:""
                        }
                        this.organizationArray.push(organizationObj)
                }
            }
          },
          permissionSet(){
              if(this.permission===true){
                  this.$notify({ 
                      group: 'foo',
                      type: 'error', 
                      title: 'Hata!',
                      text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                  })
                  return true
              }else{
                  return false
              }
          },
          undefinedValue(value){
              return value=' '
          },
          updateCustomField(event){
              let obj={}
              obj[event.target.id]=event.target.value
              this.update(event,obj)
          },
          update(data,id,value){
              let dataObje={}
              let obj={}
              let url=""
              if((typeof value !== 'object') && ((value.includes(' am') && value.includes('-') && value.includes(':')) || (value.includes(' pm') && value.includes('-') && value.includes(':')))){
                  obj[id]={"$date": new Date(value)}
              }else{
                  obj[id]=value
              }
              
              if(this.postField==="deal"){
                  url="updateDeal"
                  dataObje['dealId']=data._id.$oid
                  dataObje['dealUpdateObj']=obj
              }else if(this.postField==="organization"){
                  url="updateOrganization"
                  dataObje['objId']=data._id.$oid
                  dataObje['updateObj']=obj
              }else if(this.postField==="contact"){
                  url="updateContact"
                  dataObje['objId']=data._id.$oid
                  dataObje['updateObj']=obj
              }else if(this.postField==="product"){
                  url="updateProduct"
                  dataObje['objId']=data._id.$oid
                  dataObje['updateObj']=obj
              }else{
                  url="updateActivity"
                  dataObje['objId']=data._id.$oid
                  dataObje['updateObj']=obj
              }
               
              axios({
                  method:'POST',
                  url:`/${url}`,
                  baseURL: this.baseUrl,
                  data: dataObje,
                  withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  if(res.data.status.code==0){
                      if(this.postField==="deal"){
                          this.newData=res.data.content.deal 
                      }else if(this.postField==="organization") {
                          this.newData=res.data.content.organization
                      }else if(this.postField==="contact") {
                          this.newData=res.data.content.contact
                      }else if(this.postField==="product") {
                          this.newData=res.data.content.product
                      }else if(this.postField==="activity") {
                          this.newData=res.data.content.activity
                      }
                      this.$emit('updateData',true)
                      this.$emit('returnCustomData',this.newData)
                      this.selected=undefined
                       
                  }else{
                       
                  }
              })
          },
          customFieldChecked(checkedValue,value,edit){
              let check=false
              if(checkedValue!==undefined){
                  if(checkedValue.val!==undefined){
                      if(checkedValue.val!==""){
                          if(typeof(checkedValue)=="number" || typeof(checkedValue)=="string"){
                              if(checkedValue.toString()===value.toString()){
                                  check=true
                              }
                          }else{
                              if(edit!==undefined){
                                  if(checkedValue.val.toString()===value.toString()){
                                      check=true
                                  }
                              }else{
                                  checkedValue.forEach(element => {
                                      if(element.toString()===value.toString()){
                                          check=true
                                      }
                                  });
                              }
                              
                          }
                      }
                  }else{
                      if(checkedValue!==""){
                          if(typeof(checkedValue)=="number" || typeof(checkedValue)=="string"){
                              if(checkedValue.toString()===value.toString()){
                                  check=true
                              }
                          }else if(typeof(checkedValue)=="object"){
                              checkedValue.forEach(element => {
                                  if(element.toString()===value.toString()){
                                      check=true
                                  }
                              });
                          }else{
                              if(edit!==undefined){
                                  if(checkedValue.toString()===value.toString()){
                                      check=true
                                  }
                              }else{
                                  checkedValue.forEach(element => {
                                      if(element.toString()===value.toString()){
                                          check=true
                                      }
                                  });
                              }
                              
                          }
                      }
                  }
                  
              }
              return check
          },
          
          updateChooseCustomField(checkArrays,event){
              let checkArraysNew=[]
              if(checkArrays.val!=undefined){
                  checkArraysNew=checkArrays.val    
              }else if(checkArrays==""){
                  checkArraysNew=[]
              }else{
                  checkArraysNew=checkArrays
              }
              if(checkArraysNew!==undefined){
                  let obj={}
                  let url=""
                  let dataObje={}
                  if(event.target.type==="checkbox"){
                      if(event.target.checked){
                          if(checkArraysNew.indexOf(event.target.value)===-1){
                              checkArraysNew.push(parseInt(event.target.value))
                          }
                      }else{
                          checkArraysNew.splice(checkArraysNew.findIndex(item => item == event.target.value),1)
                      }
                      obj[event.target.id]=checkArraysNew
                      this.checkboxCheck={
                        [event.target.id]:checkArraysNew
                      }
                      this.editList[event.target.id]=checkArraysNew
                      
                  }
                  if(event.target.type==="radio"){
                      if(event.target.checked){
                          obj[event.target.id]=parseInt(event.target.value)  
                          this.editList[event.target.id]=parseInt(event.target.value) 
                          this.$set(this.radioCheck, event.target.id, parseInt(event.target.value))                 
                      }
                  }
                  if(this.edit){
                      //this.data=this.editList
                  }
                  if(this.postField==="deal"){
                      url="updateDeal"
                      dataObje['dealId']=this.data._id.$oid
                      dataObje['dealUpdateObj']=obj
                  }else if(this.postField==="organization"){
                      url="updateOrganization"
                      var orgId = ''
                      if(this.type=='profil'){
                          orgId = this.data._id.$oid
                      }else if(this.type=='save'){
                          orgId = this.editList._id.$oid
                      }
                      dataObje['objId']= orgId
                      dataObje['updateObj']=obj
                  }else if(this.postField==="contact"){
                      url="updateContact"
                      var orgId = ''
                      if(this.type=='profil'){
                          orgId = this.data._id.$oid
                      }else if(this.type=='save'){
                          orgId = this.editList._id.$oid
                      }
                      dataObje['objId']= orgId
                      dataObje['updateObj']=obj
                  }else if(this.postField==="product"){
                      url="updateProduct"
                      if(this.type=='profil'){
                          orgId = this.data._id.$oid
                      }else if(this.type=='save'){
                          orgId = this.editList._id.$oid
                      }
                      dataObje['objId']=orgId
                      dataObje['updateObj']=obj
                  }else{
                      url="updateActivity"
                      var orgId = ''
                      if(this.type=='profil'){
                          orgId = this.data._id.$oid
                      }else if(this.type=='save'){
                          orgId = this.editList._id.$oid
                      }
                      dataObje['objId']=orgId
                      dataObje['updateObj']=obj
                  }
                   
                  axios({
                      method:'POST',
                      url:`/${url}`,
                      baseURL: this.baseUrl,
                      data:dataObje,
                      withCredentials:true
                  }).then((res)=>{
                      return res
                  }).then((res)=>{
                      if(res.data.status.code==0){
                          if(this.postField==="deal"){
                              this.newData=res.data.content.deal 
                          }else if(this.postField==="organization") {
                              this.newData=res.data.content.organization
                          }else if(this.postField==="contact") {
                              this.newData=res.data.content.contact
                          }else if(this.postField==="product") {
                              this.newData=res.data.content.product
                          }else if(this.postField==="activity") {
                              this.newData=res.data.content.activity
                          }
                          this.$emit('updateData',true)
                          this.$emit('returnCustomData',this.newData)
                          this.newData["edit"]=true
                          this.$store.dispatch('editLine', this.newData)
                          this.selected=undefined
                           
                      }else{
                           
                      }
                  })
              }
          },
          updateDateCustomField(id){
              let obj={}
              let url=""
              let dataObje={}
              obj[id]=new Date(this.date)
              if(this.postField==="deal"){
                  url="updateDeal"
                  dataObje['dealId']=this.data._id.$oid
                  dataObje['dealUpdateObj']=obj
              }else if(this.postField==="organization"){
                  url="updateOrganization"
                  dataObje['objId']=this.data._id.$oid
                  dataObje['updateObj']=obj
              }else if(this.postField==="contact"){
                  url="updateContact"
                  dataObje['objId']=this.data._id.$oid
                  dataObje['updateObj']=obj
              }
               
              axios({
                  method:'POST',
                  url:`/${url}`,
                  baseURL: this.baseUrl,
                  data:dataObje,
                  withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  if(res.data.status.code==0){
                      if(this.postField==="deal"){
                          this.newData=res.data.content.deal 
                      }else if(this.postField==="organization") {
                          this.newData=res.data.content.organization
                      }else if(this.postField==="contact") {
                          this.newData=res.data.content.contact
                      }else if(this.postField==="product") {
                              this.newData=res.data.content.product
                      }else if(this.postField==="activity") {
                        this.newData=res.data.content.activity
                      }
                      this.$emit('updateData',true)
                      this.$emit('returnCustomData',this.newData)
                      this.selected=undefined
                       
                  }else{
                       
                  }
              })
          },
          setResult(result,type,getid){
              this.selected=undefined
              if(type==="contact"){
                  
                  this.contactArray.find(c=>c.id==getid).name=this.getFullNameOfContact(result)
                  this.contactArray.find(c=>c.id==getid).isHidden=false
                  this.contactArray.find(c=>c.id==getid).cid=result._id.$oid
                  this.contactArray.find(c=>c.id==getid).selectName=this.getFullNameOfContact(result)
                  this.allCustomFields[getid]={$oid:this.contactArray.find(c=>c.id==getid).cid}
              }
              if(type==="organization"){
                  this.organizationArray.find(c=>c.id==getid).name=this.filterName(result.name)
                  this.organizationArray.find(c=>c.id==getid).isHidden=false
                  this.organizationArray.find(c=>c.id==getid).oid=result._id.$oid
                  this.organizationArray.find(c=>c.id==getid).selectName=this.filterName(result.name)
                  this.allCustomFields[getid]={$oid:this.organizationArray.find(c=>c.id==getid).oid}
              }
              if(type==="profilContact"){
                this.contactArray.find(c=>c.id==getid).name=this.getFullNameOfContact(result)
                this.contactArray.find(c=>c.id==getid).isHidden=false
                this.contactArray.find(c=>c.id==getid).cid=result._id.$oid
                this.contactArray.find(c=>c.id==getid).selectName=this.getFullNameOfContact(result)
                  if(this.data!=undefined){
                     this.update(this.data,getid,{$oid:this.contactArray.find(c=>c.id==getid).cid})
                  }else{
                     this.update(this.editList,getid,{$oid:this.contactArray.find(c=>c.id==getid).cid})
                  }
              }
              if(type==="profilOrganization"){
                  this.organizationArray.find(c=>c.id==getid).name=this.filterName(result.name)
                  this.organizationArray.find(c=>c.id==getid).isHidden=false
                  this.organizationArray.find(c=>c.id==getid).oid=result._id.$oid
                  this.organizationArray.find(c=>c.id==getid).selectName=this.filterName(result.name)
                  if(this.data!=undefined){
                     this.update(this.data,getid,{$oid:this.organizationArray.find(c=>c.id==getid).oid})
                  }else{
                     this.update(this.editList,getid,{$oid:this.organizationArray.find(c=>c.id==getid).oid})
                  }
              }
          },
          changeValue(event,field,item){
              if(field===1 || field===2 || field===5 || field===10 || field===11 || field===12){

                this.allCustomFields[event.target.id]=event.target.value
                
                // if(field===12){
                //     let obj = {}
                   
                //     obj._id=event.target.id
                //     obj.value=event.target.value
                //     obj.name=item.name
                //     obj.field_type=field
                //     this.allCustomFields[event.target.id]=obj
                //     console.log(this.allCustomFields[event.target.id]);
                // }
                // else{
                //     this.allCustomFields[event.target.id]=event.target.value
                // }
                
                if(event.target.value===""){
                    delete this.allCustomFields[event.target.id]
                }
              }
              if(field===3){
                // this.allCustomFields[event.id]=this.$moment(event.value).format()
                // if(event.value===""){
                //     delete this.allCustomFields[event.id]
                // }
                // console.log('event.value')
                // console.log(event.value)
                let obj = {'$date': new Date(event.value)}
                this.allCustomFields[event.id]=obj
                if(event.value===""){
                    delete this.allCustomFields[event.id]
                }
              }
              if(field===4){
                  this.allCustomFields[event.target.id]={$oid:event.target.value}
                  if(event.target.value==="0" || event.target.value===""){
                      delete this.allCustomFields[event.target.id]
                  }
              }
              if(field===6){
                  if(event.target.checked){
                      if(this.singleChoose.indexOf(event.target.value)===-1){
                          if(event.target.type==="radio"){
                              this.singleChoose=[]
                              this.singleChoose.push(parseInt(event.target.value))   
                          }else{
                              this.singleChoose=[]
                              this.singleChoose.push(parseInt(event.target.value))   
                          }
                      }
                  }else{
                      this.singleChoose.splice(singleChoose.findIndex(item => item == event.target.value),1)
                  }
                  this.allCustomFields[event.target.id]=this.singleChoose
                  this.$set(this.radioCheck, event.target.id, this.singleChoose)
                  if(this.singleChoose===[]){
                      delete this.allCustomFields[event.target.id]
                  }
              }
              if(field===7){
                  if(event.target.checked) {
                     if(this.multiChoose[event.target.id]=== undefined) {
                        this.multiChoose[event.target.id]=[];
                    }
                    if (this.multiChoose[event.target.id].indexOf(event.target.value) === -1) {
                        this.multiChoose[event.target.id].push(parseInt(event.target.value));
                    }
                   } else {
                        this.multiChoose[event.target.id].splice(this.multiChoose.findIndex(item => item == event.target.value), 1);
                    }
                    this.allCustomFields[event.target.id] = this.multiChoose[event.target.id];
                    this.$set(this.checkboxCheck, event.target.id, this.multiChoose[event.target.id])
                    if (this.multiChoose[event.target.id] === []) {
                        delete this.allCustomFields[event.target.id];
                    }
              }
              if(field===8){
                  if(this.organization===""){
                      delete this.allCustomFields[event.target.id]
                  }
              }
              if(field===9){
                  if(this.contact===""){
                      delete this.allCustomFields[event.target.id]
                  }
              }
              this.$emit('returnCustomField',this.allCustomFields)
          },
          quickOrganization(id){
               
              axios({
                  method:'POST',
                  url:'/quickFilterOrganization',
                  baseURL: this.baseUrl,
                  data: {
                      search:this.organizationArray.find(c=>c.id==id).name,
                  },
                  withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  if(!res.data.status){
                      this.$router.push('/logout')
                  }
                  if(res.data.status.code==0){
                      this.items=res.data.content.organizations
                      this.organizationArray.find(c=>c.id==id).isHidden= true
                       
                  }else{
                       
                  }
              })
          },
          quickContact(id){
               
              axios({
                  method:'POST',
                  url:'/quickFilterContact',
                  baseURL: this.baseUrl,
                  data: {
                      search:this.contactArray.find(c=>c.id==id).name,
                      //organizationId:this.organizationId
                  },
                  withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  if(!res.data.status){
                      this.$router.push('/logout')
                  }
                  if(res.data.status.code==0){
                      this.items=res.data.content.contacts
                      if(this.items.length>0){
                        this.contactArray.find(c=>c.id==id).isHidden= true
                      }
                       
                  }else{
                       
                  }
              })
          },
            updateSelectCustomField(checkArrays,event){
              let checkArraysNew=[]
              if(checkArrays.val!=undefined){
                  checkArraysNew=checkArrays.val    
              }else if(checkArrays==""){
                  checkArraysNew=[]
              }else{
                  checkArraysNew=checkArrays
              }
              if(checkArraysNew!==undefined){
                  let obj={}
                  let url=""
                  let dataObje={}
                  obj[event.target.value]=""
                  if(this.edit){
                      this.data=this.editList
                  }
                  if(this.postField==="deal"){
                      url="updateDeal"
                      dataObje['dealId']=this.data._id.$oid
                      dataObje['dealUpdateObj']=obj
                  }else if(this.postField==="organization"){
                      url="updateOrganization"
                      var orgId = ''
                      if(this.type=='profil'){
                          orgId = this.data._id.$oid
                      }else if(this.type=='save'){
                          orgId = this.editList._id.$oid
                      }
                      dataObje['objId']= orgId
                      let checkArray=this.checkArray
                      dataObje['updateObj']=obj
                  }else if(this.postField==="contact"){
                      url="updateContact"
                      var orgId = ''
                      if(this.type=='profil'){
                          orgId = this.data._id.$oid
                      }else if(this.type=='save'){
                          orgId = this.editList._id.$oid
                      }
                      dataObje['objId']= orgId
                      dataObje['updateObj']=obj
                  }else if(this.postField==="product"){
                      url="updateProduct"
                      if(this.type=='profil'){
                          orgId = this.data._id.$oid
                      }else if(this.type=='save'){
                          orgId = this.editList._id.$oid
                      }
                      dataObje['objId']=orgId
                      dataObje['updateObj']=obj
                  }else{
                      url="updateActivity"
                      var orgId = ''
                      if(this.type=='profil'){
                          orgId = this.data._id.$oid
                      }else if(this.type=='save'){
                          orgId = this.editList._id.$oid
                      }
                      dataObje['objId']=orgId
                      dataObje['updateObj']=obj
                  }
                   
                  axios({
                      method:'POST',
                      url:`/${url}`,
                      baseURL: this.baseUrl,
                      data:dataObje,
                      withCredentials:true
                  }).then((res)=>{
                      return res
                  }).then((res)=>{
                      if(res.data.status.code==0){
                          if(this.postField==="deal"){
                              this.newData=res.data.content.deal 
                          }else if(this.postField==="organization") {
                              this.newData=res.data.content.organization
                          }else if(this.postField==="contact") {
                              this.newData=res.data.content.contact
                          }else if(this.postField==="product") {
                              this.newData=res.data.content.product
                          }else if(this.postField==="activity") {
                              this.newData=res.data.content.activity
                          }
                          this.$emit('updateData',true)
                          this.$emit('returnCustomData',this.newData)
                          this.newData["edit"]=true
                          this.$store.dispatch('editLine', this.newData)
                          this.selected=undefined
                           
                      }else{
                           
                      }
                  })
              }
          },
          setDisplayField(event){
              if(event.target.checked){
                  if(this.checkArray.indexOf(event.target.value)===-1){
                      this.checkArray.push(event.target.value)
                  }
              }else{
                  for(let i in this.checkArray){
                      if(this.checkArray[i]===event.target.value){
                          this.checkArray.splice(i,1)
                         this.updateSelectCustomField(this.checkArray,event)
                      }
                     
                  }
                //    this.checkArray.splice(this.checkArray.findIndex(item => item === event.target.value),1)
              }
          },
          moment: function () {
              return moment();
          },
          ...mapActions([
              'updateLoading'
          ]),
          setInputs(isPage){
              if(isPage=="forDetails"){
                  var data = this.data
                  for(var c in this.customField){
                      if(data[this.customField[c]._id.$oid]!=undefined && this.checkArray.indexOf(this.customField[c]._id.$oid)===-1){
                            this.checkArray.push(this.customField[c]._id.$oid)
                      }
                  }
              }else{
                  var data = this.editArray
              }
              if(this.customField!==undefined && data != undefined){
                  
                this.contactArray=[]
                this.organizationArray=[]
                var neworg={}
                for (var item in this.customField){
                   
                
                        let edObj={}
                        var customid=this.customField[item]['_id']['$oid']
                        edObj['name']=this.customField[item]['name']
                        edObj['val']=''
                        edObj['isEditMode']=false
                        edObj['type']=this.customField[item]['field_type']
                        
                        if(edObj['type']==4){
                            let oid = {};
                            oid["$oid"] = "";
                            edObj["val"] = {};
                            edObj["val"]["_id"] = oid;
                            edObj['users']=this.users
                        }else if(this.customField[item]['field_type']==7||edObj['type']==6){
                            edObj['options']=this.customField[item]['options']
                            edObj['val']=''
                        }
                        else if(this.customField[item]['field_type']==9){
                            let id = this.customField[item]['_id']['$oid']
                            var contactObj={}
                            contactObj= {
                                name:"",
                                id:id,
                                isHidden:"",
                                selectName:"",
                                cid:""
                            }
                            this.contactArray.push(contactObj)
                        }
                        else if(this.customField[item]['field_type']==8){
                            let id = this.customField[item]['_id']['$oid']
                            var organizationObj={}
                            organizationObj= {
                                name:"",
                                id:id,
                                isHidden:"",
                                selectName:"",
                                oid:""
                            }
                            this.organizationArray.push(organizationObj)
                        }
                        var colInActivity = data.hasOwnProperty(customid)
                        
                        if(!colInActivity){
                            neworg[customid]=edObj
                        }
                        for(var eai in data){
                            if(eai === '_id'){
                                neworg[eai]=data['_id']
                            }
                            if(eai === this.customField[item]['_id']['$oid']){
                                
                                if(data[eai].val!==undefined){
                                    neworg[eai]=data[eai].val
                                }else{
                                    neworg[eai]=data[eai]
                                }
                            }
                        }
                        
                }
                let obj ={}
                for(var i in neworg){
                    if(neworg[i]!==null){
                        if(neworg[i].val!==undefined){
                            obj[i]=neworg[i].val
                        }else{
                            obj[i]=neworg[i]
                        }
                        // console.log('type bak')
                        // console.log(typeof neworg[i])
                        if(typeof neworg[i] === 'object' && '$date' in neworg[i]){
                            obj[i] = moment(neworg[i].$date).format('YYYY/MM/DD');
                            // console.log('neworg')
                            // console.log(obj[i])
                        }
                    }else{
                        obj[i]=neworg[i]
                    }
                    if(this.contactArray.find(c=>c.id==i)!==undefined && obj[i]!==null && obj[i]._id!==undefined){
                        this.contactArray.find(c=>c.id==i).name=this.getFullNameOfContact(obj[i])
                        this.contactArray.find(c=>c.id==i).selectName=this.getFullNameOfContact(obj[i])
                        this.contactArray.find(c=>c.id==i).id=i
                        this.contactArray.find(c=>c.id==i).cid=obj[i]._id.$oid
                        this.contactArray.find(c=>c.id==i).isHidden=false
                    }
                    if(this.organizationArray.find(c=>c.id==i)!==undefined && obj[i]!==null && obj[i]._id!==undefined){
                        this.organizationArray.find(c=>c.id==i).name=this.filterName(obj[i].name)
                        this.organizationArray.find(c=>c.id==i).selectName=this.filterName(obj[i].name)
                        this.organizationArray.find(c=>c.id==i).id=i
                        this.organizationArray.find(c=>c.id==i).oid=obj[i]._id.$oid
                        this.organizationArray.find(c=>c.id==i).isHidden=false
                    }
                    if(isPage=="forDetails"){
                        this.detailEditList=obj
                    }else{
                        this.editList=obj
                    }
                }
              }
          }
      },
      watch: {
          organization: _.debounce(function(addr) {
              if(this.organization===""){
              this.isHiddenOrganization = false
              }
              if(this.selectOrganization!==this.organization){
                  this.quickOrganization()
              }
          }, 300),
          editArray(){
              this.setInputs()
          },
          data(){
              this.setInputs("forDetails")
          },
          customField(){
              this.setInputs()
              if(this.edit==false){
              this.setCustomField()
              }
          }
      },
  }
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
  .container-fluid{
    padding-bottom: 20px;
  }
  .login-form input{
    border-radius: 20px;
  }
  .new-input{
      line-height: 1.6 !important;
  }
  h1{
    color: white;
  }
  .dealBtnStyle button {
    font-family: "font-family-bold";
    border-radius: 20px;
    background-color: white;
    height: 27px;
    border: 1px solid #66D0FF80;
    color: #66D0FF;
    font-weight: normal;
    font-size: 10px;
  }
  .dealBtnStyle button.active {
    background-color: #66D0FF!important;
    border: 1px solid #66D0FF;
    color: white;
  }
  .multiChoose label{
      cursor: pointer;
      color: #666;
  }
  .multiChoose input[type="checkbox"], input[type="radio"]{
      position: absolute;
      right: 9000px;
  }
  /*Check box*/
  .multiChoose input[type="checkbox"] + .label-text:before{
      content: "\f096";
      font-family: "FontAwesome";
      speak: none;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      -webkit-font-smoothing:antialiased;
      width: 1em;
      display: inline-block;
      margin-right: 5px;
  }
  .multiChoose input[type="checkbox"]:checked + .label-text:before{
      content: "\f14a";
      color: #66D0FF!important;
      animation: effect 250ms ease-in;
  }
  .multiChoose input[type="checkbox"]:disabled + .label-text{
      color: #aaa;
  }
  .multiChoose input[type="checkbox"]:disabled + .label-text:before{
      content: "\f0c8";
      color: #ccc;
  }
  @keyframes effect{
      0%{transform: scale(0);}
      25%{transform: scale(1.3);}
      75%{transform: scale(1.4);}
      100%{transform: scale(1);}
  }
  /*Radio box*/
  .multiChoose input[type="radio"] + .label-text:before{
      content: "\f10c";
      font-family: "FontAwesome";
      speak: none;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
      line-height: 1;
      -webkit-font-smoothing:antialiased;
      width: 1em;
      display: inline-block;
      margin-right: 5px;
  }
  .multiChoose input[type="radio"]:checked + .label-text:before{
      content: "\f192";
      color: #66D0FF!important;
      animation: effect 250ms ease-in;
  }
  .multiChoose input[type="radio"]:disabled + .label-text{
      color: #aaa;
  }
  .multiChoose input[type="radio"]:disabled + .label-text:before{
      content: "\f111";
      color: #ccc;
  }
  .hide{
      display: none
  }
  .hide_visible {
      visibility: hidden;
  }
  .show{
      visibility: visible;
  }
  .field:hover .icon-line-duzenle{
      visibility: visible;
  }
  .iptal:before{
      color:red
  } 
  #customFieldScroll{
      /*height: 250px;
      overflow-y: scroll;
      overflow-x: hidden;*/
  }
  /* Kişi, firma ve fırsat kartlarında kullanılan özel alan görünümü.
     Kart dar olduğunda Bootstrap'in iç içe satır boşlukları alanları taşırıp
     iki kolonu kullanılmaz hale getiriyordu. */
  .custom-field-profile {
      width: 100%;
      margin-right: 0;
      margin-left: 0;
  }
  .custom-field-profile > .col-12,
  .custom-field-profile > .row,
  .custom-field-profile .col-sm-6 {
      min-width: 0;
  }
  .custom-field-profile > .row {
      width: 100%;
      margin-right: 0;
      margin-left: 0;
  }
  .custom-field-profile .col-sm-6 {
      margin-bottom: 12px;
  }
  .custom-field-profile .new-input,
  .custom-field-profile .new-input-disable,
  .custom-field-profile .new-select,
  .custom-field-profile .new-ctk,
  .custom-field-profile .position-relative {
      min-width: 0;
      max-width: 100%;
  }
  .custom-field-profile .new-ctk {
      display: block;
      width: 100%;
  }
  .custom-field-profile .new-dropdown {
      max-width: calc(100% - 30px);
      max-height: 240px;
      overflow: auto;
  }
  @media (max-width: 991.98px) {
      .custom-field-profile .col-sm-6 {
          flex: 0 0 100%;
          max-width: 100%;
      }
  }
  .vdatetime:after{
      display: none;
  }
  .new-input{
      line-height: 2.2;
  }
  @media (max-width: 768px) {
  .new-input{
      line-height: 1;
    }
  }
  </style>
